<template>
  <div>
    <template
      v-if="
        !isBookshelfBookLoading &&
        getCurrentBookshelfBooks &&
        getCurrentBookshelfBooks.length
      "
    >
      <ul class="item_list">
        <BaseBook
          v-for="(book, index) in getCurrentBookshelfBooks"
          :key="index"
          :book="book"
          :library="true"
        />
      </ul>
      <!-- Pagination START -->
      <Pagination
        :current-page="currentPage"
        :total-count="getBookshelfTotalBookCount"
        :item-per-page="booksPerPage"
        @paginate="paginate"
      />
      <!-- Pagination END -->
    </template>
    <!-- ########### EMPTY LIBRARY ############ -->
    <template
      v-if="
        !isBookshelfBookLoading &&
        getCurrentBookshelfBooks &&
        !getCurrentBookshelfBooks.length
      "
    >
      <div class="library_alert p_empty">
        <div class="stage_msg">
          <div class="not_found_img"></div>
          <p class="cell">
            <span class="tit pb-1">{{ $t('library.booktable.8882') }}</span>
            <br /><span class="sub">{{ $t('library.booktable.358') }}</span>
          </p>
          <div class="btn_wrap">
            <div>
              <router-link :to="{ name: 'store' }" class="box_btn">
                <span class="an_t">{{ $t('library.booktable.6510') }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- ########### EMPTY LIBRARY END ############ -->
  </div>
</template>
<script>
/* TODO: @stan
  1. Make sure first and last button only appear over 10
  2. Resolve design issue with more than 10 pages
*/
import { mapGetters } from 'vuex'

import { BOOKSHELF_BOOK_GET_LIST } from '@/store/types'

export default {
  name: 'BookTable',
  data() {
    return {
      currentPage: 1,
      booksPerPage: 30,
      sort: 'PD' //RD
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelfBooks',
      'isBookshelfBookLoading',
      'getBookshelfTotalBookCount'
    ])
  },
  methods: {
    async paginate(page) {
      this.currentPage = page

      await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, { page })
    }
  }
}
</script>
<style src="@/assets/css/page_library.css"></style>
